var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.583 4.744 7.583 8.53 8.845 8.53 8.845 7.268 15.155 7.268 15.155 6.006 8.845 6.006 8.845 4.744 7.583 4.744"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.5832,
    y: 12.3155,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.1071,
    y: 12.3155,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.631,
    y: 12.3155,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.1548,
    y: 12.3155,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.5832,
    y: 14.8393,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.1071,
    y: 14.8393,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.631,
    y: 14.8393,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.1548,
    y: 14.8393,
    width: 1.2619,
    height: 1.2619
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9406,10.4226V6.0058H17.0477V4.7439H15.7858V8.53h1.2619V7.2678h.631V9.1607H6.3213V7.2678h.631V6.0058H5.0594v13.25H18.9406Zm-1.2619,7.5716H6.3213V10.4226H17.6787Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.93d17e9496f2f3259e48755130684405.svg";
export { ForwardRef as ReactComponent };